const HIDE_SPINNER = "HIDE_SPINNER";
const SHOW_SPINNER = "SHOW_SPINNER";

const defaultState = {
  showing: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case HIDE_SPINNER:
      return defaultState;
    case SHOW_SPINNER:
      return { ...state, showing: true };
    default:
      return state;
  }
};

export const showSpinner = () => ({
  type: SHOW_SPINNER
});

export const hideSpinner = () => ({
  type: HIDE_SPINNER
});
